import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  scrollableContent: { maxHeight: 'calc(100vh - 165px)', overflow: 'auto' },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  formControl: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '40%',
    },
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:last-child)': {
      paddingBottom: '24px',
    },
    '& p': {
      padding: '4px',
    },
  },
  itemField: {
    flexGrow: 1,
  },
  itemDetails: {
    display: 'flex',
    '&[data-block="true"]': {
      flexDirection: 'column',
    },
    '& > div': {
      display: 'flex',
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  itemAction: {
    backgroundColor: '#FFFCE6',
    display: 'inline-block',
  },
  itemOld: {
    color: '#00000073',
    textDecoration: 'line-through',
    lineBreak: 'anywhere',
    '& img': {
      opacity: '.5',
    },
  },
  itemNew: {
    lineBreak: 'anywhere',
  },
}));
